import axios from 'axios';

const baseUrl = process.env.REACT_APP_BASE_URI;

const instance = axios.create({
  baseURL: `${baseUrl}/api`,
  timeout: 10000,
  headers: {
    Accept: 'application/json'
  }
});

// Chiamata al servizio
export const getCall = async (appName, paymentId, tokenId, conditionAccepted) => {
  // Data
  let data = {
    provider: 0,
    autoConfirmation: true,
    successUrl: `${baseUrl}/ok`,
    failedUrl: `${baseUrl}/ko`
  };

  if (conditionAccepted) {
    data = Object.assign({ conditionAccepted: true }, data);
  }

  // Config
  const config = {
    headers: {
      'x-cons-app': appName
    }
  };

  // Request
  const res = await instance.post(`/${paymentId}/tokens/${tokenId}`, data, config);
  return res;
};